<fdb-alert-message
[header] = "'Sie sind uns unbekannt!'"
[content] = "'Sie sind zwar im Active Directory bekannt, jedoch ist die Sychronisation mit der Anwendung noch nicht erfolgt.'"
[feed] = "'Entweder versuchen Sie spaeter nochmal oder wenden Sie sich an den Administrator.'"
[type]= "'warning'"></fdb-alert-message>
